import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoiHttpClient } from 'loi-lti-common';

@Injectable({
  providedIn: 'root'
})
export class ExemptionService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string) { }

    getExemptionRequestLink(contractNumber: string): Observable<string> {
      return this.httpClient.get<string>(`${this.baseUrl}api/Activation/${contractNumber}/exemption-link`);
    }
}

